export default "__VITE_ASSET__DiPCLFHA__"